import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useApiClient } from "@/api/client-context";
import {
  processModelFileQueryOptions,
  processModelQueryOptions,
} from "@/features/process-design/use-process-model";

/**
 * モデルの図（実行状態なし）。
 *
 * 起票前はインスタンスが無いので詳細 API から XML を取れない。モデルの主 BPMN
 * ファイルを直接読む（2 段階: モデル詳細で primary_file_name を知り、その file を取る）。
 */
export function useModelDiagram(
  processModelId: string | null,
): UseQueryResult<{ readonly xml: string | null }> {
  const client = useApiClient();
  const id = processModelId ?? "";

  const model = useQuery({
    ...processModelQueryOptions(client, id),
    enabled: processModelId !== null,
  });

  const fileName = model.data?.primaryFileName ?? null;

  return useQuery({
    ...processModelFileQueryOptions(client, id, fileName ?? ""),
    enabled: processModelId !== null && fileName !== null,
    select: (file) => ({ xml: file.contents === "" ? null : file.contents }),
  });
}
